import React from 'react';
import {Redirect} from 'react-router-dom';

const PageNotFound = () => {
    return <Redirect to="/baseRedirection" />
};

export default PageNotFound;